import Vue from 'vue'
import Vuex from 'vuex'

import validators from './modules/validators'

import configuration from './modules/configuration'
import gui from './modules/gui'
import profile from './modules/profile'

import changetracking from './modules/change-tracking'
import services from './modules/services'

import locationaddresses from './modules/location-addresses'
import locationevents from './modules/location-events'
import locationlocationservices from './modules/location-locationservices'
import locations from './modules/locations'
import locationservices from './modules/locationservices'

import useraddresses from './modules/user-addresses'
import userlocations from './modules/user-locations'
import userlogins from './modules/user-logins'
import userprofessions from './modules/user-professions'
import userservices from './modules/user-services'
import users from './modules/users'

import deliverynotes from './modules/delivery-note'
import enduseraddresses from './modules/enduser-addresses'
import endusertenantlogins from './modules/enduser-tenant-logins'
import endusers from './modules/endusers'
import medicalinstitutionaddresses from './modules/medicalinstitution-adresses'
import medicalinstitutions from './modules/medicalinstitutions'
import medicalpersonaddresses from './modules/medicalperson-adresses'
import medicalpersonaffiliations from './modules/medicalperson-affiliations'
import medicalpersons from './modules/medicalpersons'
import orderlytasks from './modules/orderlytasks'
import orderparsedata from './modules/orderparsedata'
import orders from './modules/orders'
import procurementmessages from './modules/procurementmessages'
import sellingpoints from './modules/sellingpoints'
import tenants from './modules/tenants'

import marketingproducts from './modules/marketingproducts'
import products from './modules/products'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    configuration,
    gui,
    profile,
    validators,

    changetracking,
    services,

    locations,
    locationaddresses,
    locationevents,
    locationservices,
    locationlocationservices,

    users,
    useraddresses,
    userprofessions,
    userlogins,
    userservices,
    userlocations,

    sellingpoints,
    endusers,
    enduseraddresses,
    tenants,
    endusertenantlogins,
    procurementmessages,
    deliverynotes,

    medicalpersons,
    medicalinstitutions,
    medicalpersonaddresses,
    medicalinstitutionaddresses,
    medicalpersonaffiliations,

    orderparsedata,
    orderlytasks,

    orders,
    products,
    marketingproducts
  }
})
